/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as ResetPasswordImport } from './routes/reset-password';
import { Route as IndexImport } from './routes/index';
import { Route as SsoIndexImport } from './routes/sso/index';
import { Route as MfaPromptIndexImport } from './routes/mfa-prompt/index';
import { Route as SsoCallbackImport } from './routes/sso/callback';
import { Route as SsoTenantImport } from './routes/sso/$tenant';
import { Route as SignOutCallbackImport } from './routes/sign-out/callback';
import { Route as SignInCallbackImport } from './routes/sign-in/callback';

// Create/Update Routes

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const SsoIndexRoute = SsoIndexImport.update({
  id: '/sso/',
  path: '/sso/',
  getParentRoute: () => rootRoute,
} as any);

const MfaPromptIndexRoute = MfaPromptIndexImport.update({
  id: '/mfa-prompt/',
  path: '/mfa-prompt/',
  getParentRoute: () => rootRoute,
} as any);

const SsoCallbackRoute = SsoCallbackImport.update({
  id: '/sso/callback',
  path: '/sso/callback',
  getParentRoute: () => rootRoute,
} as any);

const SsoTenantRoute = SsoTenantImport.update({
  id: '/sso/$tenant',
  path: '/sso/$tenant',
  getParentRoute: () => rootRoute,
} as any);

const SignOutCallbackRoute = SignOutCallbackImport.update({
  id: '/sign-out/callback',
  path: '/sign-out/callback',
  getParentRoute: () => rootRoute,
} as any);

const SignInCallbackRoute = SignInCallbackImport.update({
  id: '/sign-in/callback',
  path: '/sign-in/callback',
  getParentRoute: () => rootRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/reset-password': {
      id: '/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof ResetPasswordImport;
      parentRoute: typeof rootRoute;
    };
    '/sign-in/callback': {
      id: '/sign-in/callback';
      path: '/sign-in/callback';
      fullPath: '/sign-in/callback';
      preLoaderRoute: typeof SignInCallbackImport;
      parentRoute: typeof rootRoute;
    };
    '/sign-out/callback': {
      id: '/sign-out/callback';
      path: '/sign-out/callback';
      fullPath: '/sign-out/callback';
      preLoaderRoute: typeof SignOutCallbackImport;
      parentRoute: typeof rootRoute;
    };
    '/sso/$tenant': {
      id: '/sso/$tenant';
      path: '/sso/$tenant';
      fullPath: '/sso/$tenant';
      preLoaderRoute: typeof SsoTenantImport;
      parentRoute: typeof rootRoute;
    };
    '/sso/callback': {
      id: '/sso/callback';
      path: '/sso/callback';
      fullPath: '/sso/callback';
      preLoaderRoute: typeof SsoCallbackImport;
      parentRoute: typeof rootRoute;
    };
    '/mfa-prompt/': {
      id: '/mfa-prompt/';
      path: '/mfa-prompt';
      fullPath: '/mfa-prompt';
      preLoaderRoute: typeof MfaPromptIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/sso/': {
      id: '/sso/';
      path: '/sso';
      fullPath: '/sso';
      preLoaderRoute: typeof SsoIndexImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/sign-in/callback': typeof SignInCallbackRoute;
  '/sign-out/callback': typeof SignOutCallbackRoute;
  '/sso/$tenant': typeof SsoTenantRoute;
  '/sso/callback': typeof SsoCallbackRoute;
  '/mfa-prompt': typeof MfaPromptIndexRoute;
  '/sso': typeof SsoIndexRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/sign-in/callback': typeof SignInCallbackRoute;
  '/sign-out/callback': typeof SignOutCallbackRoute;
  '/sso/$tenant': typeof SsoTenantRoute;
  '/sso/callback': typeof SsoCallbackRoute;
  '/mfa-prompt': typeof MfaPromptIndexRoute;
  '/sso': typeof SsoIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/sign-in/callback': typeof SignInCallbackRoute;
  '/sign-out/callback': typeof SignOutCallbackRoute;
  '/sso/$tenant': typeof SsoTenantRoute;
  '/sso/callback': typeof SsoCallbackRoute;
  '/mfa-prompt/': typeof MfaPromptIndexRoute;
  '/sso/': typeof SsoIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/reset-password'
    | '/sign-in/callback'
    | '/sign-out/callback'
    | '/sso/$tenant'
    | '/sso/callback'
    | '/mfa-prompt'
    | '/sso';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/reset-password'
    | '/sign-in/callback'
    | '/sign-out/callback'
    | '/sso/$tenant'
    | '/sso/callback'
    | '/mfa-prompt'
    | '/sso';
  id:
    | '__root__'
    | '/'
    | '/reset-password'
    | '/sign-in/callback'
    | '/sign-out/callback'
    | '/sso/$tenant'
    | '/sso/callback'
    | '/mfa-prompt/'
    | '/sso/';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  SignInCallbackRoute: typeof SignInCallbackRoute;
  SignOutCallbackRoute: typeof SignOutCallbackRoute;
  SsoTenantRoute: typeof SsoTenantRoute;
  SsoCallbackRoute: typeof SsoCallbackRoute;
  MfaPromptIndexRoute: typeof MfaPromptIndexRoute;
  SsoIndexRoute: typeof SsoIndexRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInCallbackRoute: SignInCallbackRoute,
  SignOutCallbackRoute: SignOutCallbackRoute,
  SsoTenantRoute: SsoTenantRoute,
  SsoCallbackRoute: SsoCallbackRoute,
  MfaPromptIndexRoute: MfaPromptIndexRoute,
  SsoIndexRoute: SsoIndexRoute,
};

export const routeTree = rootRoute._addFileChildren(rootRouteChildren)._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/reset-password",
        "/sign-in/callback",
        "/sign-out/callback",
        "/sso/$tenant",
        "/sso/callback",
        "/mfa-prompt/",
        "/sso/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/sign-in/callback": {
      "filePath": "sign-in/callback.tsx"
    },
    "/sign-out/callback": {
      "filePath": "sign-out/callback.tsx"
    },
    "/sso/$tenant": {
      "filePath": "sso/$tenant.tsx"
    },
    "/sso/callback": {
      "filePath": "sso/callback.tsx"
    },
    "/mfa-prompt/": {
      "filePath": "mfa-prompt/index.tsx"
    },
    "/sso/": {
      "filePath": "sso/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
